angular.module('elogbooksServices').service('complianceDocumentsResponseService', function ($rootScope) {
    'use strict';

    let cache = {};
    const service = this;

    this.resolveUserKey = function (userManager) {
        return userManager && userManager.user && userManager.user.id ? userManager.user.id : null;
    };

    this.resolveJobKey = function (jobResponse) {
        return jobResponse && jobResponse.id ? jobResponse.id : null;
    };

    this.getLive = function (userKey, jobKey) {
        if (!cache[userKey] || !cache[userKey][jobKey] || typeof cache[userKey][jobKey].live === 'undefined') {
            return null;
        }

        return cache[userKey][jobKey].live;
    };

    this.setLive = function (userKey, jobKey, value) {
        if (!cache[userKey]) {
            cache[userKey] = {};
        }

        if (!cache[userKey][jobKey]) {
            cache[userKey][jobKey] = {};
        }

        cache[userKey][jobKey].live = value;
    };

    this.clearAll = function () {
        cache = {};
    };

    this.normalize = function (apiClient, response, wrapTopLevelDocuments) {
        if (!response) {
            return response;
        }

        if (typeof wrapTopLevelDocuments === 'undefined') {
            wrapTopLevelDocuments = true;
        }

        if (wrapTopLevelDocuments
            && angular.isArray(response.documents)
            && !response.availableAtJobCreationDocuments
            && !response.additionalLiveDocuments
        ) {
            response = {
                availableAtJobCreationDocuments: response
            };
        }

        if (response.availableAtJobCreationDocuments) {
            response.availableAtJobCreationDocuments = normalizeSectionDocuments(
                apiClient,
                response.availableAtJobCreationDocuments
            );
        }

        if (response.additionalLiveDocuments) {
            response.additionalLiveDocuments = normalizeSectionDocuments(
                apiClient,
                response.additionalLiveDocuments
            );
        }

        return response;
    };

    this.toResponseDataDocuments = function (apiClient, documents) {
        if (!angular.isArray(documents)) {
            return [];
        }

        return documents.map(function (document) {
            return document && angular.isFunction(document.getLink)
                ? document
                : new apiClient.ResponseData(document);
        });
    };

    function normalizeSectionDocuments(apiClient, section) {
        if (!section || !angular.isArray(section.documents)) {
            return section;
        }

        section.documents = service.toResponseDataDocuments(apiClient, section.documents);

        return section;
    }

    function isJobDetailsState(state) {
        return !!(state && state.name && state.name.indexOf('.jobs.list.details') !== -1);
    }

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        if (isJobDetailsState(fromState) && !isJobDetailsState(toState)) {
            cache = {};
        }
    });
});
